module.exports = __webpack_public_path__ + "static/team-2-2451fb86051ef9b388b03dbd97953927.jpg";